export const general = [
    {
        id: 0,
        name: "Relatório de ocorrências",
        description: "Relatório com as informações sobre ocorrências gerais (perda de ticket, furtos e etc)."
    }
]